import { Link } from 'react-router-dom';
import HeroParticles from '@/components/feature/HeroParticles';

export default function Hero() {
  return (
    <section className="relative h-[100dvh] min-h-[680px] flex items-center justify-center overflow-hidden bg-[#0d0d1a]">
      <HeroParticles />
      <div className="absolute inset-0 bg-grid" aria-hidden="true"></div>

      {/* 右下のパープル光源 */}
      <div
        className="absolute bottom-0 right-0 w-[60%] h-[60%] pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 100% 100%, rgba(124,58,237,0.45), rgba(168,85,247,0.15) 45%, transparent 70%)',
        }}
        aria-hidden="true"
      ></div>

      <div
        className="blob w-[600px] h-[600px] top-1/4 left-1/4"
        style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)', opacity: 0.2 }}
      ></div>
      <div
        className="blob w-[400px] h-[400px] bottom-1/4 right-1/4"
        style={{
          background: 'linear-gradient(135deg, #a855f7, #a78bfa)',
          opacity: 0.16,
          animationDelay: '-7s',
        }}
      ></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-up inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#1e1e3f] border border-[#3b3b6b]">
          <span className="w-2 h-2 rounded-full bg-[#a855f7]"></span>
          <span className="text-sm font-medium tracking-[0.22em] uppercase text-[#a78bfa]">Luvira Inc.</span>
        </div>
        <h1
          className="animate-fade-up font-extrabold text-white text-3xl md:text-5xl lg:text-6xl leading-tight mt-6"
          style={{ animationDelay: '120ms' }}
        >
          会社を成長させたい。
          <br className="hidden md:block" />
          けれど、経営者の時間と判断、
          <br className="hidden md:block" />
          組織の限界が、成長を止めている。
        </h1>
        <p
          className="animate-fade-up mt-6 text-[#a0a0b0] text-base md:text-lg leading-relaxed max-w-3xl mx-auto"
          style={{ animationDelay: '240ms' }}
        >
          LUVIRAはAIを活用し、会社の成長を妨げている業務・情報・判断の滞りを見つけます。
          <br className="hidden md:block" />
          経営者に集中している仕事を見直します。組織に分散している情報をつなげます。
          <br className="hidden md:block" />
          現場が動きやすい業務の仕組みづくりを支援します。
        </p>
        <div
          className="animate-fade-up mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          style={{ animationDelay: '360ms' }}
        >
          <Link
            to="/contact/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 px-8 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white transition-all duration-300 hover:brightness-110 hover:scale-[1.02] hover:shadow-[0_14px_30px_rgba(124,58,237,0.4)]"
          >
            成長を止めている課題を相談する
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-[#a0a0b0] text-2xl"></i>
      </div>
    </section>
  );
}